/* BM CART RECS — "related products" upsell carousel for the cart page and cart drawer.
   Uses Shopify's product recommendations (intent=related), the same source as the PDP's related products,
   for every product in the cart: newest cart item first, then the others in turn, de-duplicated,
   excluding products already in the cart. Falls back to the upsell collection cards when Shopify returns none.
   Results are cached per product for the session, so re-renders after cart changes refill instantly. */
(function () {
  'use strict';
  if (window.__bmRecsReady) return;
  window.__bmRecsReady = true;

  var TTL = 30 * 60 * 1000;
  var MAX_SOURCES = 3;        /* cart products used as recommendation seeds */
  var STORE_KEY = 'bm:recs:v1';
  var cache = {};
  var inflight = {};
  try { cache = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}') || {}; } catch (_) { cache = {}; }

  function persist() {
    try {
      var keys = Object.keys(cache).sort(function (a, b) { return cache[b].t - cache[a].t; });
      keys.slice(20).forEach(function (k) { delete cache[k]; });
      sessionStorage.setItem(STORE_KEY, JSON.stringify(cache));
    } catch (_) {}
  }
  function fresh(id) { return cache[id] && (Date.now() - cache[id].t) < TTL; }

  function fetchRecs(base, id) {
    if (fresh(id)) return Promise.resolve(cache[id].h);
    if (inflight[id]) return inflight[id];
    var url = base + (base.indexOf('?') === -1 ? '?' : '&') +
      'section_id=bm-cart-recs&product_id=' + encodeURIComponent(id) + '&limit=10&intent=related';
    inflight[id] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = doc.querySelector('[data-bm-recs-result]');
        var h = res ? res.innerHTML : '';
        cache[id] = { t: Date.now(), h: h };
        persist();
        delete inflight[id];
        return h;
      })
      .catch(function () { delete inflight[id]; return ''; });
    return inflight[id];
  }

  function toCards(html) {
    var t = document.createElement('template');
    t.innerHTML = html || '';
    return Array.prototype.slice.call(t.content.querySelectorAll('.bm-up'));
  }

  /* Round-robin across the cart's products so each item gets its related picks, newest item first */
  function compose(box, htmls) {
    var exclude = box.getAttribute('data-exclude') || ',';
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 8;
    var lists = htmls.map(toCards);
    var seen = {}, out = [];
    for (var i = 0; out.length < limit; i++) {
      var any = false;
      for (var l = 0; l < lists.length && out.length < limit; l++) {
        var card = lists[l][i];
        if (!card) continue;
        any = true;
        var id = card.getAttribute('data-product-id');
        if (!id || seen[id] || exclude.indexOf(',' + id + ',') !== -1) continue;
        seen[id] = true;
        out.push(card);
      }
      if (!any) break;
    }
    return out;
  }

  function fallbackCards(box) {
    var t = box.querySelector('template[data-bm-recs-fallback]');
    return t ? Array.prototype.slice.call(t.content.cloneNode(true).querySelectorAll('.bm-up')) : [];
  }

  function updateNav(box) {
    var track = box.querySelector('[data-bm-recs-track]');
    var nav = box.querySelector('[data-bm-recs-nav]');
    if (!track || !nav) return;
    var max = track.scrollWidth - track.clientWidth;
    nav.hidden = !(max > 4);
    var prev = nav.querySelector('[data-bm-recs-prev]');
    var next = nav.querySelector('[data-bm-recs-next]');
    if (prev) prev.disabled = track.scrollLeft <= 4;
    if (next) next.disabled = track.scrollLeft >= max - 4;
  }

  function render(box, cards) {
    var ctx = box.getAttribute('data-ctx') || 'page';
    var track = box.querySelector('[data-bm-recs-track]');
    if (!track) return;
    track.textContent = '';
    cards.forEach(function (card, i) {
      /* Unique ids per context: the same card can exist in the drawer and on the cart page */
      var sizes = card.querySelector('[data-bm-sizes]');
      var btn = card.querySelector('[data-bm-upsell-add][aria-controls]');
      if (sizes) {
        var sid = 'bm-sizes-' + ctx + '-r' + (i + 1);
        sizes.id = sid;
        if (btn) btn.setAttribute('aria-controls', sid);
      }
      card.setAttribute('role', 'group');
      card.setAttribute('aria-roledescription', 'slide');
      card.setAttribute('aria-label', (i + 1) + ' of ' + cards.length);
      track.appendChild(card);
    });
    track.setAttribute('tabindex', cards.length ? '0' : '-1');
    box.hidden = cards.length === 0;
    if (!track.__bmBound) {
      track.__bmBound = true;
      track.addEventListener('scroll', function () { updateNav(box); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { updateNav(box); }).observe(track);
    }
    updateNav(box);
  }

  function fill(box) {
    var ids = (box.getAttribute('data-products') || '').split(',').filter(Boolean).slice(0, MAX_SOURCES);
    if (!ids.length) { box.hidden = true; return; }
    var key = ids.join(',') + '|' + box.getAttribute('data-exclude');
    if (box.__bmKey === key) return;
    box.__bmKey = key;
    var base = box.getAttribute('data-url') || '/recommendations/products';

    /* Everything cached: render synchronously, so a cart re-render never flashes */
    if (ids.every(fresh)) {
      var c = compose(box, ids.map(function (id) { return cache[id].h; }));
      render(box, c.length ? c : fallbackCards(box));
      return;
    }
    Promise.all(ids.map(function (id) { return fetchRecs(base, id); })).then(function (htmls) {
      if (!document.contains(box) || box.__bmKey !== key) return;
      var cards = compose(box, htmls);
      render(box, cards.length ? cards : fallbackCards(box));
    });
  }

  function fillAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bm-recs]'), fill);
  }

  /* Arrows */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bm-recs-prev], [data-bm-recs-next]');
    if (!btn) return;
    var box = btn.closest('[data-bm-recs]');
    var track = box && box.querySelector('[data-bm-recs-track]');
    if (!track) return;
    e.preventDefault();
    var card = track.querySelector('.bm-up');
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    var perView = Math.max(1, Math.floor((track.clientWidth + gap) / step));
    var dir = btn.hasAttribute('data-bm-recs-prev') ? -1 : 1;
    track.scrollBy({ left: dir * step * perView, behavior: 'smooth' });
  });

  /* Keyboard: left / right on the focused track */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var track = e.target.closest && e.target.closest('[data-bm-recs-track]');
    if (!track || e.target !== track) return;
    e.preventDefault();
    var card = track.querySelector('.bm-up');
    var step = card ? card.getBoundingClientRect().width : track.clientWidth * 0.5;
    track.scrollBy({ left: (e.key === 'ArrowLeft' ? -1 : 1) * step, behavior: 'smooth' });
  });

  /* Cart regions are re-rendered by assets/bm-cart.js, which then fires bm:cart:updated */
  document.addEventListener('bm:cart:updated', function () { fillAll(); });

  function init() {
    var drawer = document.getElementById('ltn__utilize-cart-menu');
    /* Cart page: now. Drawer: when the browser is idle, so it is ready before the drawer opens */
    Array.prototype.forEach.call(document.querySelectorAll('[data-bm-recs]'), function (box) {
      if (drawer && drawer.contains(box) && !drawer.classList.contains('ltn__utilize-open')) return;
      fill(box);
    });
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    idle(function () { fillAll(drawer || document); });
    if (drawer) {
      new MutationObserver(function () {
        if (drawer.classList.contains('ltn__utilize-open')) { fillAll(drawer); Array.prototype.forEach.call(drawer.querySelectorAll('[data-bm-recs]'), updateNav); }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.BMCartRecs = { refresh: function () { fillAll(); } };
})();
